const episodes = [
  { id: 'iYck6cHU1cg', title: 'Episode 1' },
  { id: 'd4MP13YitRM', title: 'Episode 2' },
  { id: 'vyGcF47Gjjc', title: 'Episode 3' },
  { id: 'iYnhK_jq5Xc', title: 'Episode 4' },
  { id: 'z0LS5XoaI3c', title: 'Episode 5' },
  { id: 'WoIQcxwp0fY', title: 'Episode 6' },
  { id: 'rqoGakIUF2g', title: 'Episode 7' },
  { id: 'iSEMcHMXtnI', title: 'Episode 8' },
  { id: 'JFFvob7Wr7o', title: 'Episode 9' },
  { id: 'l8w2nOlLLyw', title: 'Episode 10' },
  { id: '1hHWrlgVsXk', title: 'Episode 11' },
  { id: 't7O4ybTJlpo', title: 'Episode 12' },
  { id: 'zj8XGSa0zA0', title: 'Interlude' },
];

export default episodes;
